document.addEventListener('DOMContentLoaded', function() {
    // Obtener todos los elementos de cantidad
    const quantitySelectors = document.querySelectorAll('.quantity-selector');

    quantitySelectors.forEach(selector => {
        const minusBtn = selector.querySelector('.minus-btn');
        const plusBtn = selector.querySelector('.plus-btn');
        const quantityInput = selector.querySelector('input[type="number"]');
        
        const productIdFull = quantityInput.id.split('_').slice(1).join('_'); // Obtener el ID completo del producto incluyendo el índice

        // Botón de restar
        minusBtn.addEventListener('click', function() {
            let currentQuantity = parseInt(quantityInput.value);
            if (currentQuantity > 1) {
                quantityInput.value = currentQuantity - 1;
                updateHiddenQuantityField(productIdFull, quantityInput.value);
            }
        });

        // Botón de sumar
        plusBtn.addEventListener('click', function() {
            let currentQuantity = parseInt(quantityInput.value);
            quantityInput.value = currentQuantity + 1;
            updateHiddenQuantityField(productIdFull, quantityInput.value);
        });

        // Actualizar el campo oculto de cantidad en el formulario de añadir al carrito
        function updateHiddenQuantityField(productIdFull, quantity) {
            const hiddenQuantityInput = document.getElementById('product_quantity_' + productIdFull);
            if (hiddenQuantityInput) {
                hiddenQuantityInput.value = quantity;
            }
        }
    });
});
